import { render, staticRenderFns } from "./ModalSolicitacaoCancelamentoGeral.vue?vue&type=template&id=35c99456&scoped=true"
import script from "./ModalSolicitacaoCancelamentoGeral.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCancelamentoGeral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c99456",
  null
  
)

export default component.exports